import { Component, Input, OnInit } from '@angular/core';
import { EventsService, VariablesService } from '../../../shared/services';
import { ISipCause } from '../../models/fundraiser.model';

@Component({
  selector: 'app-memorial-nudge',
  templateUrl: './memorial-nudge.component.html',
  styleUrls: ['./memorial-nudge.component.scss']
})
export class MemorialNudgeComponent implements OnInit {

  @Input() cause: ISipCause;

  constructor(
    public variablesService: VariablesService,
    public eventsService: EventsService
  ) { }

  ngOnInit() {
  }

  event() {
    const systemEvent = {
      eventName: 'Contribution Initiated',
      info_1: 'position',
      info_2: 'banner',
      page_name: this.variablesService.pageName
    };
    this.eventsService.sendSystemEvent(systemEvent).subscribe(_ => _);
  }

}
